import http from './client';
import axios, { AxiosProgressEvent } from 'axios';
import { IUploadedFile, IUploadLink, IUploadRequest } from '../typings/IFile';

const uploadToCourse = async (
  files: Array<File>,
  callback?: (progress: number) => void,
  courseId?: number,
  lessonId?: number
): Promise<Array<IUploadLink>> => {
  if (callback) {
    callback(5);
  }
  let url = "/panel/files/upload";
  const fileData = new FormData();
  if (courseId) {
    url += '?course_id=' + courseId;
    fileData.append("course_id", courseId.toString());
  }
  if (lessonId) {
    fileData.append("lesson_id", lessonId.toString());
  }
  for (let i = 0; i < files.length; i++) {
    fileData.append(`files[${i}][name]`, files[i].name);
    fileData.append(`files[${i}][size]`, files[i].size.toString());
    fileData.append(`files[${i}][mimetype]`, files[i].type);
  }
  const uploadedLinksResponse = await http.post<Array<IUploadLink>>(url, fileData);
  if (uploadedLinksResponse.data[0].message && uploadedLinksResponse.data[0].message === "SERVICES_DISABLED") {
    window.openServicesDisabledModal(true);
    return [];
  }
  const uploadedFiles = [];
  for (let i = 0; i < uploadedLinksResponse.data.length; i++) {
    const uploadedFile = uploadedLinksResponse.data[i];
    await uploadToCDN(uploadedFile, files[i], callback);
    uploadedFiles.push(uploadedFile);
  }
  return uploadedFiles;
};

const uploadToCDN = async (
  uploadLink: IUploadLink | string,
  file: File,
  callback?: (progress: number) => void
): Promise<void> => {
  try {
    const formData = new FormData();
    formData.append('file', file, file.name);
    await axios.put(typeof uploadLink === 'string' ? uploadLink : uploadLink.link, file, {
      headers: {
        'Content-Type': file.type,
      },
      onUploadProgress: (event: AxiosProgressEvent) => {
        if (callback) {
          const completed = Math.round((event.loaded * 100) / event.total) - 15;
          if (completed > 0) {
            callback(completed);
          }
        }
      },
    });
    if (typeof uploadLink !== 'string') {
      // оповещаем бэк об успешной загрузке файла на селектел
      const processResponse = await http.post(`/api/files/process/`, {
        file: uploadLink.file.id
      });
    }
    if (callback) {
      callback(90);
      setTimeout(() => callback(100), 200);
    }
  } catch (e) {
    if (typeof uploadLink !== 'string') {
      // оповещаем бэк об ошибке при загрузке файла
      http.post(`/api/files/uploadaborted`, {
        file: uploadLink.file.id,
        error: e.toString(),
      });
    }
    throw e;
  }
};

async function uploadTemp(file: File, callback?: (progress: number) => void): Promise<IUploadRequest> {
  try {
    const response = await http.post<IUploadRequest>('/api/files/upload-temp', {
      size: file.size,
      mimetype: file.type
    });
    await uploadToCDN(response.data.uploadLink, file, callback);
    return response.data;
  } catch (e) {
    throw e;
  }
}


async function upload(file: File, callback: (progress: number) => void = () => {}, params: {course_id?: string | number, group_id?: string | number, file_id?: string | number, useSystem?: boolean}): Promise<IUploadRequest> {
  try {
    const response = await http.post<IUploadRequest>('/api/files/upload', {
      name: file.name,
      size: file.size,
      mimetype: file.type,
      ...params,
    });
    await uploadToCDN(response.data.uploadLink, file, callback);
    return response.data;
  } catch (e) {
    throw e;
  }
}


async function uploadByLink(files: Array<{link: string, name: string, }>, courseId?: string | number, groupId?: string | number, lessonId?: string | number): Promise<Array<IUploadLink>> {
  const res = await http.post('/panel/files/upload', {files}, {
    params: {
      course_id: courseId,
      group_id: groupId,
      lesson_id: lessonId,
    }
  });
  return res.data;
}


async function remove(payload: Array<number> | 'all', course_id: number | string) {
  const res = await http.post('/api/files/delete', typeof payload === 'string' ? {type: 'all', course_id} : {id: payload})
}

export const file = {
  uploadToCourse, uploadTemp, upload, uploadByLink, remove
}

